/* eslint-disable react/jsx-key */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'
import {
  ExportComponent,
  getApiTargetInfo,
  getCompanyNameMap,
  getStationsNameMap,
} from 'core'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { connect } from 'react-redux'

import {
  getAPSAdMappingData,
  deleteAPSAdMappingDelete,
  getRoles,
} from 'api/pgads.js'
import { Button, Input, Popconfirm, message } from 'antd'

import R from 'ramda'
import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'
import {
  CriteriaRow,
  Content,
  Filler,
  Title,
  FullHeightSizer,
} from './../../../core/screen-util'
import { exportDataComponent, rowHeaderRender } from 'core/utils'
import { ErrorContext, SpinContext } from '../../../context'
import ApsAdModal from './ApsAdModal'

const ApsAdMapping = ({ apiTargetInfo, stationNameMap, companyNameMap }) => {
  const { setSpinning, spinning } = useContext(SpinContext)
  const { onError } = useContext(ErrorContext)

  const [selectionChange, setSelectionChnage] = useState({})
  const [data, setData] = useState([])
  const [fuzzyFilter, setFuzzyFilter] = useState()
  const [roleMap, setRoleMap] = useState({})
  const [roleList, setRoleList] = useState([])
  const [companyRoleIdList, setCompanyRoleIdList] = useState([])
  const [stationRoleIdList, setStationRoleIdList] = useState([])
  const setDataMapSetter = data => {
    const sd = {}
    data
      .filter(d => d.toggleable)
      .forEach(dt => {
        const { id } = dt
        const oid = id.substr(
          0,
          id.indexOf('$$') === -1 ? id.length : id.indexOf('$$')
        )
        if (sd[oid]) {
          const ad = sd[oid]
          ad.push(dt)
        } else {
          sd[oid] = [dt]
        }
      })

    const stationRoleIdList = []
    const companyRoleIdList = []

    Object.keys(sd).forEach(k => {
      if (sd[k][0].shifts === 'COMPANY') companyRoleIdList.push(k)
      else if (sd[k][0].shifts === 'STATION') stationRoleIdList.push(k)
    })

    setRoleMap(sd)
    setCompanyRoleIdList(R.uniq(companyRoleIdList))
    setStationRoleIdList(R.uniq(stationRoleIdList))
  }

  const GridRef = useRef()
  const onRetrieve = useCallback(
    _ => {
      setSpinning(true)
      getAPSAdMappingData(apiTargetInfo).fork(onError, data => {
        setSpinning(false)
        setData(data)
      })
      getRoles(apiTargetInfo)().fork(onError, roles => {
        setRoleList(roles.filter(r => r.toggleable))
        setDataMapSetter(roles.filter(r => r.toggleable))
      })
    },
    [apiTargetInfo, onError, setSpinning]
  )

  useEffect(onRetrieve, [onRetrieve])

  const onSelectionChnage = selRow => {
    // setShowDialog(true)
    setSelectionChnage(selRow)
    //   setSelectionChnage({ ...selRow, visible: true })
  }
  const [showDialog, setShowDialog] = useState({ visible: false })
  const showModalDilog = isNew =>
    isNew
      ? setShowDialog({ visible: true, isNew })
      : setShowDialog({ ...selectionChange, isNew: false, visible: true })
  const hideModal = isRetieve => {
    setShowDialog(false)
    if (isRetieve) onRetrieve()
  }
  const deleteData = _ => {
    deleteAPSAdMappingDelete(apiTargetInfo)([selectionChange]).fork(
      onError,
      _ => {
        message.info('Data Deleted')
        onRetrieve()
      }
    )
  }
  const nameDataGetter = ({ rowData }) => {
    const { type, gadsName } = rowData
    if (type === 'STATION') return stationNameMap[gadsName] || gadsName
    if (type === 'COMPANY') return companyNameMap[gadsName] || gadsName
    if (type === 'ROLE') {
      return (
        (roleMap[gadsName] && roleMap[gadsName][0]?.displayName) || gadsName
      )
    }
  }
  const headers = [
    strCol({
      ident: 'type',
      display: 'Type',
      sortOrder: 'asc',
      sortIndexGetter: ({ rowData }) =>
        rowData.type === 'ROLE'
          ? 'AAA'
          : rowData.type === 'COMPANY'
          ? 'BBB'
          : 'CCC',
    }),
    strCol({
      ident: 'adName',
      display: 'AD Name',
      sortOrder: 'asc',
      width: 250,
    }),
    strCol({
      ident: 'gadsName2',
      display: 'GADS Name',
      width: 300,
      dataGetter: nameDataGetter,
      sortOrder: 'asc',
    }),
    modifierCol,
    modifiedDateCol,
  ]

  const title = 'AD Mapping'
  return (
    <div>
      <CriteriaRow>
        <Title>{title}</Title>
        <Button
          loading={spinning}
          onClick={onRetrieve}
          style={{ marginLeft: '10px' }}
          type="primary"
          icon="database"
        >
          Retrieve
        </Button>
        <Button
          onClick={_ => showModalDilog(true)}
          icon="plus-circle"
          style={{ backgroundColor: '#e6f7ff', marginLeft: '10px' }}
        >
          Insert
        </Button>
        <Button
          style={{
            marginLeft: '10px',
          }}
          onClick={_ => showModalDilog(false)}
          icon="edit"
          type="primary"
          disabled={Object.keys(selectionChange || {}).length <= 0}
        >
          Update
        </Button>
        <Popconfirm
          title="Are you sure?"
          okText="Yes"
          cancelText="No"
          onConfirm={_ => deleteData()}
          placement="topRight"
        >
          <Button
            icon="delete"
            style={{
              marginLeft: '10px',
            }}
            type="danger"
            disabled={Object.keys(selectionChange || {}).length <= 0}
          >
            Remove
          </Button>
        </Popconfirm>
        <Filler />
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          css={{
            marginLeft: '10px',
            marginRight: '10px',
            flex: '0 0 200px',
          }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
        <ExportComponent
          getData={_ => exportDataComponent(GridRef, data, fuzzyFilter)}
          data={data}
          headers={headers.map(d => ({
            ...d,
            rowHeaderBackgroundColor: '#eee',
          }))}
          fileName={title}
          btnStyle={{ marginRight: '10px' }}
          disabled={data.length <= 0}
        />
      </CriteriaRow>
      <FullHeightSizer heightOffset={220}>
        {({ height }) => (
          <Content css={{ height }}>
            <Grid
              ref={GridRef}
              data={data || []}
              headers={headers.map(e => ({
                ...e,
                isFiltered: true,
              }))}
              altBgColor="#ebebeb"
              render={virtualizedGridRenderer({
                autoFixColByKey: false,
                rowHeaderRender,
                height: height - 40,
                width: 1000,
                headerRowHeight: 30,
              })}
              fuzzyFilter={fuzzyFilter}
              onSelectionChange={({ selectedRows }) => {
                onSelectionChnage(selectedRows[0])
              }}
              initialSortOptions={headers}
              sortOptions={headers}
              sortEnabled={false}
              isEditable={false}
              selectionType="row"
              selectionMode="single"
            />
          </Content>
        )}
      </FullHeightSizer>
      {showDialog.visible && (
        <ApsAdModal
          hide={hideModal}
          data={showDialog}
          allData={data}
          plantData={[]}
          roles={roleList}
          roleMap={roleMap}
          apiTargetInfo={apiTargetInfo}
          stationNameMap={stationNameMap}
          companyNameMap={companyNameMap}
          companyRoleIdList={companyRoleIdList}
          stationRoleIdList={stationRoleIdList}
        />
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  companyNameMap: getCompanyNameMap(state),
  stationNameMap: getStationsNameMap(state),
})

export default connect(mapStateToProps)(ApsAdMapping)
